import { jsx as p } from "react/jsx-runtime";
import { useMemo as h } from "react";
import c from "../InputContainer/index.js";
import g from "../RawInput/index.js";
import { m as x } from "../../common-Di3flird.js";
import { extractInputContainerProps as I } from "../../utils/inputs.js";
function N(a) {
  const {
    disabled: o,
    inputClassName: m,
    readOnly: e,
    required: i,
    type: s = "text",
    withDiffView: n,
    value: t,
    prevValue: r,
    ...u
  } = a, [f, l] = I(
    u
  ), d = h(
    () => x(t, r, n),
    [t, r, n]
  );
  return /* @__PURE__ */ p(
    c,
    {
      ...f,
      disabled: o,
      readOnly: e,
      required: i,
      highlightMode: d,
      prevValue: r,
      input: /* @__PURE__ */ p(
        g,
        {
          ...l,
          value: t,
          className: m,
          disabled: o,
          readOnly: e,
          required: i,
          type: s
        }
      )
    }
  );
}
export {
  N as default
};
